export const LightenDarkenColor = (col, amt) => {
  var usePound = false;

  if (!col) {
    return col;
  }
  if (col[0] == '#'){
    col = col.slice(1);
    usePound = true;
  }

  var num = parseInt(col, 16);

  var r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  var b = ((num >> 8) & 0x00ff) + amt;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  var g = (num & 0x0000ff) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
};


export const adjustBrightness = (col, amt) => {
  var usePound = false;
  if (!col) {
    return col;
  }
  if (col[0] == "#") {
    col = col.slice(1);
    usePound = true;
  }
  var R = parseInt(col.substring(0, 2), 16);
  var G = parseInt(col.substring(2, 4), 16);
  var B = parseInt(col.substring(4, 6), 16);
  R = R + amt;
  G = G + amt;
  B = B + amt;
  if (R > 255) R = 255;
  else if (R < 0) R = 0;
  if (G > 255) G = 255;
  else if (G < 0) G = 0;
  if (B > 255) B = 255;
  else if (B < 0) B = 0;
  var RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
  var GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
  var BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));
  return (usePound ? "#" : "") + RR + GG + BB;
}


export const isDarkColor = (hexcolor) => {
  if (!hexcolor) {
    return false;
  }
  hexcolor = hexcolor.replace("#", "");
  var r = parseInt(hexcolor.substr(0, 2), 16);
  var g = parseInt(hexcolor.substr(2, 2), 16);
  var b = parseInt(hexcolor.substr(4, 2), 16);
  var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
  return (yiq >= 185) ? false : true;
}
